<main class="public-contact-main">
  <section class="public-contact-card">
    <div class="brand-box">
      <img src="assets/img/NOVAXLOGO.png" alt="NOVAX EC" />
    </div>

    <header class="public-contact-header">
      <span>Formulario público</span>
      <h1>Actualización de datos de contacto</h1>
      <p>
        Busque su nombre, selecciónelo y registre su correo personal y número
        celular.
      </p>
    </header>

    <section class="search-box" *ngIf="!selectedUser">
      <label class="field">
        <span>Buscar por nombre o apellido</span>
        <div class="search-row">
          <input
            type="text"
            [(ngModel)]="search"
            placeholder="Ejemplo: Joel Torres"
            (keydown.enter)="searchUsers()"
          />

          <button
            type="button"
            class="btn btn-primary"
            (click)="searchUsers()"
            [disabled]="loadingSearch"
          >
            <ng-container *ngIf="!loadingSearch; else searchingTpl">
              Buscar
            </ng-container>

            <ng-template #searchingTpl> Buscando... </ng-template>
          </button>
        </div>
      </label>

      <div class="user-list" *ngIf="users.length > 0">
        <button
          type="button"
          class="user-item"
          *ngFor="let user of users"
          (click)="selectUser(user)"
        >
          <strong>{{ user.apellidos }} {{ user.nombre }}</strong>
          <small>Seleccionar usuario</small>
        </button>
      </div>
    </section>

    <section class="form-box" *ngIf="selectedUser">
      <div class="selected-user">
        <div>
          <span>Usuario seleccionado</span>
          <strong
            >{{ selectedUser.apellidos }} {{ selectedUser.nombre }}</strong
          >
        </div>

        <button type="button" class="btn btn-light" (click)="clearSelection()">
          Cambiar
        </button>
      </div>

      <label class="field">
        <span>Número de cédula</span>

        <input
          type="text"
          [(ngModel)]="cedula"
          placeholder="1100000000"
          inputmode="numeric"
        />
      </label>

      <label class="field">
        <span>Correo personal</span>
        <input
          type="email"
          [(ngModel)]="personalEmail"
          placeholder="correo.personal@gmail.com"
        />
      </label>

      <label class="field">
        <span>Número celular</span>
        <input
          type="text"
          [(ngModel)]="phone"
          placeholder="0999999999"
          inputmode="numeric"
        />
      </label>

      <button
        type="button"
        class="btn btn-primary full"
        (click)="save()"
        [disabled]="saving"
      >
        <ng-container *ngIf="!saving; else savingTpl">
          Guardar datos
        </ng-container>

        <ng-template #savingTpl> Guardando... </ng-template>
      </button>
    </section>

    <div class="alert alert-success" *ngIf="message">
      {{ message }}
    </div>

    <div class="alert alert-error" *ngIf="error">
      {{ error }}
    </div>
  </section>
</main>
